<div class="collection-search-card">
    <div class="thumbnail">
        <app-collection-card
            [learningObject]="learningObject"
            [gtmPrefix]="gtmPrefix"
            [gtmDataCardNumber]="gtmDataCardNumber"
        ></app-collection-card>
    </div>
    <div class="content selenium-result-content">
        <app-link
            [appRouterLink]="learningObject.routerLink"
            [class]="getResourceBodyClass()"
            [attr.data-gtmlabel]="learningObject.canonicalUrl"
            [attr.data-gtmresultindex]="gtmDataCardNumber"
        >
            <app-card-title><span [innerHtml]="learningObject.title"></span></app-card-title>
        </app-link>

        <app-card-description
            ><span [innerHtml]="learningObject.description | safeTruncate: 130"></span
        ></app-card-description>
        <app-search-card-meta
            [gradesDisplay]="learningObject.gradesDisplay"
            [brand]="learningObject.brand"
        >
        </app-search-card-meta>
    </div>
</div>
